var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "460B51A6-0817-489E-80A0-A009F44B6DCC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-1012.000000, -942.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Number-Entry",
    transform: "translate(1012.000000, 942.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0,
    y: 0,
    width: 130,
    height: 22
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(76.330198, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 48.603352,
    height: 14.0782123,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 15.0837989,
    y: 1.00558659,
    width: 17.4301676,
    height: 12.0670391,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5900402,9.09610684 C23.997905,9.09610684 24.3125873,9.01018025 24.5340869,8.83832708 C24.7555866,8.6664739 24.8663364,8.4209148 24.8663364,8.10164979 C24.8663364,7.87862256 24.8014141,7.69836767 24.6715695,7.56088513 C24.5417249,7.42340258 24.3423752,7.33785789 24.0735204,7.30425105 L24.0735204,7.30425105 L24.0735204,7.28592004 C24.2934925,7.24009253 24.4634362,7.14920129 24.5833515,7.01324633 C24.7032668,6.87729138 24.7632245,6.70238303 24.7632245,6.4885213 C24.7632245,6.22883205 24.6730971,6.02451772 24.4928422,5.8755783 C24.3125873,5.72663888 24.0597722,5.65216917 23.7343968,5.65216917 C23.5358109,5.65216917 23.3467724,5.68310274 23.1672813,5.74496988 C22.9877902,5.80683703 22.8293034,5.89199983 22.6918209,6.00045828 L22.6918209,6.00045828 L22.8842964,6.25709235 C23.0508031,6.15016149 23.1989787,6.07683747 23.3288233,6.03712029 C23.4586679,5.99740311 23.5969143,5.97754452 23.7435623,5.97754452 C23.9360379,5.97754452 24.0884144,6.02413582 24.2006918,6.11731844 C24.3129692,6.21050105 24.3691079,6.33881809 24.3691079,6.50226955 C24.3691079,6.70696578 24.2927287,6.86698019 24.1399703,6.98231276 C23.9872119,7.09764534 23.7802243,7.15531163 23.5190075,7.15531163 L23.5190075,7.15531163 L23.1844667,7.15531163 L23.1844667,7.48297835 L23.5144248,7.48297835 C24.1529548,7.48297835 24.4722198,7.686147 24.4722198,8.09248429 C24.4722198,8.54617668 24.1827427,8.77302287 23.6037884,8.77302287 C23.4571404,8.77302287 23.3017087,8.75430997 23.1374935,8.71688417 C22.9732782,8.67945836 22.8186103,8.62484724 22.6734899,8.5530508 L22.6734899,8.5530508 L22.6734899,8.91508816 C22.8125,8.98230185 22.955711,9.02927505 23.1031228,9.05600777 C23.2505347,9.08274049 23.4128404,9.09610684 23.5900402,9.09610684 Z",
    id: 3,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    fill: "#000000",
    x: 5.02793296,
    y: 6.70391061,
    width: 4.69273743,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8938547,4.69273743 C41.0234411,4.69273743 41.1284916,4.79778794 41.1284916,4.9273743 L41.128486,6.80373743 L43.0055866,6.80446927 C43.135173,6.80446927 43.2402235,6.90951978 43.2402235,7.03910615 C43.2402235,7.16869251 43.135173,7.27374302 43.0055866,7.27374302 L41.128486,7.27373743 L41.1284916,9.15083799 C41.1284916,9.28042435 41.0234411,9.38547486 40.8938547,9.38547486 C40.7642684,9.38547486 40.6592179,9.28042435 40.6592179,9.15083799 L40.658486,7.27373743 L38.7821229,7.27374302 C38.6525365,7.27374302 38.547486,7.16869251 38.547486,7.03910615 C38.547486,6.90951978 38.6525365,6.80446927 38.7821229,6.80446927 L40.658486,6.80373743 L40.6592179,4.9273743 C40.6592179,4.79778794 40.7642684,4.69273743 40.8938547,4.69273743 Z",
    id: "Combined-Shape-Copy",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.53293034,13.0502793 L6.53293034,10.1700201 L7.51822189,10.1700201 L7.51822189,9.70028806 L5,9.70028806 L5,10.1700201 L5.98529155,10.1700201 L5.98529155,13.0502793 L6.53293034,13.0502793 Z M8.24687936,10.1402322 C8.34158956,10.1402322 8.41529548,10.1138814 8.46799712,10.0611797 C8.52069876,10.0084781 8.54704958,9.93629976 8.54704958,9.84464473 C8.54704958,9.74840695 8.52069876,9.67431913 8.46799712,9.62238128 C8.41529548,9.57044344 8.34158956,9.54447451 8.24687936,9.54447451 C8.149114,9.54447451 8.0738805,9.57044344 8.02117886,9.62238128 C7.96847722,9.67431913 7.9421264,9.74840695 7.9421264,9.84464473 C7.9421264,9.93629976 7.96847722,10.0084781 8.02117886,10.0611797 C8.0738805,10.1138814 8.149114,10.1402322 8.24687936,10.1402322 Z M8.51267895,13.0502793 L8.51267895,10.5160178 L7.97420566,10.5160178 L7.97420566,13.0502793 L8.51267895,13.0502793 Z M10.0983109,13.0961068 C10.1991315,13.0961068 10.2965149,13.0873232 10.3904613,13.069756 C10.4844077,13.0521888 10.5611688,13.0304207 10.6207446,13.0044518 L10.6207446,13.0044518 L10.6207446,12.5988783 C10.4893724,12.6401231 10.3580002,12.6607455 10.226628,12.6607455 C10.1212247,12.6607455 10.0360619,12.6298119 9.97113958,12.5679447 C9.90621727,12.5060776 9.87375611,12.4102217 9.87375611,12.2803771 L9.87375611,12.2803771 L9.87375611,10.9238827 L10.5955395,10.9238827 L10.5955395,10.5160178 L9.87375611,10.5160178 L9.87375611,9.95233939 L9.54150663,9.95233939 L9.35819658,10.4885213 L8.98699372,10.6855796 L8.98699372,10.9238827 L9.33299145,10.9238827 L9.33299145,12.2895426 C9.33299145,12.8272521 9.58809794,13.0961068 10.0983109,13.0961068 Z M11.6656119,13.0502793 L11.6656119,9.48489874 L11.1271386,9.48489874 L11.1271386,13.0502793 L11.6656119,13.0502793 Z M13.5422486,13.0961068 C13.7148656,13.0961068 13.8683877,13.0831224 14.0028151,13.0571535 C14.1372425,13.0311845 14.2701423,12.9868846 14.4015145,12.9242537 L14.4015145,12.9242537 L14.4015145,12.4866009 C14.2533389,12.552287 14.1147106,12.5992602 13.9856298,12.6275205 C13.856549,12.6557808 13.7171569,12.669911 13.5674537,12.669911 C13.3398438,12.669911 13.1634078,12.603843 13.0381459,12.471707 C12.9128841,12.339571 12.8464342,12.1505325 12.8387963,11.9045915 L12.8387963,11.9045915 L14.5275402,11.9045915 L14.5275402,11.6135868 C14.5275402,11.2576597 14.4305386,10.9781119 14.2365354,10.7749433 C14.0425323,10.5717746 13.7782603,10.4701903 13.4437194,10.4701903 C13.0832097,10.4701903 12.7998429,10.588578 12.5936191,10.8253535 C12.3873953,11.062129 12.2842833,11.3875044 12.2842833,11.8014796 C12.2842833,12.2047617 12.3954151,12.5213534 12.6176785,12.7512548 C12.839942,12.9811562 13.148132,13.0961068 13.5422486,13.0961068 Z M13.9982324,11.5150576 L12.8479618,11.5150576 C12.8678204,11.3073062 12.9293056,11.1492013 13.0324175,11.0407428 C13.1355294,10.9322844 13.2726301,10.8780552 13.4437194,10.8780552 C13.6148088,10.8780552 13.7492362,10.9319025 13.8470016,11.0395972 C13.9447669,11.1472918 13.9951772,11.3057786 13.9982324,11.5150576 L13.9982324,11.5150576 Z",
    id: "Title",
    fill: "#9A9A9A",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberEntry);
export default __webpack_public_path__ + "static/media/NumberEntry.6bb86063d56f17ea7ab2405b171aaa32.svg";
export { ForwardRef as ReactComponent };